export default __webpack_public_path__ + "static/media/subcategory_car_10.69bae610.png";